export const TEMPLATE_REQUEST = 'TEMPLATE_REQUEST'
export const TEMPLATE_SUCCESS = 'TEMPLATE_SUCCESS'
export const TEMPLATE_FAILURE = 'TEMPLATE_FAILURE'
export const TEMPLATE_LOAD = 'TEMPLATE_LOAD'
export const LOGOUT = 'USER_LOGOUT'